import gql from 'graphql-tag'

export const MutationFeedActivateSftppush = gql(`mutation feed_activate_sftppush($auid: String!, $feed_id: ID!, $params: TransferParametersInput!) {
    feedActivateSftppush(auid: $auid, feed_id: $feed_id, params: $params) {
      url
    }
  }`)



// WEBPACK FOOTER //
// ./src/graphql/MutationFeedActivateSftppush.js